import {
    InformationCircleIcon, XIcon,
} from 'components/Icon'

import React, {useContext} from 'react'

import {
    buttonsWrapper, closeButton, content, contentInner, footer, header, heading,
    iconWrapper, text as styledText,
} from './../styles'

import Button from 'components/Button'
import {DEFAULT_HEADER_HEIGHT} from 'components/Embed/components/EmbedHeader/EmbedHeader'
import {EmbedConfirmationModalProps} from './types'
import {EmbedContext} from 'components/EmbedContext'
import {Modal} from 'components/Modal'
import {ThemeContext} from 'stitches/ThemeProvider/ThemeProvider'


import {embedTheme} from 'stitches/themes'

import {
    styled,
} from 'stitches/config'

import {
    useTranslation,
} from 'react-i18next'

const StyledContent = styled('div', content)
const StyledContentInner = styled('div', contentInner)
const StyledHeader = styled('div', header)
const StyledFooter = styled('div', footer)
const CloseButton = styled(Button, closeButton)
const StyledHeading = styled('h1', heading)
const StyledText = styled('div', styledText)
const StyledIconWrapper = styled('div', iconWrapper)
const StyledButtons = styled('div', buttonsWrapper)


const EmbedConfirmationPromiseModalView = (props: EmbedConfirmationModalProps): React.ReactElement => {
    const {
        onResolve, onReject, text, title, icon, modalProps, submitText, cancelText,
    } = props
    const {t} = useTranslation()
    const embed = useContext(EmbedContext)
    const theme = useContext(ThemeContext) as typeof embedTheme


    const onConfirm = () => {
        // eslint-disable-next-line no-unused-expressions
        onResolve && onResolve()
    }

    const handleCloseModal = () => {
        // eslint-disable-next-line no-unused-expressions
        onReject && onReject()
    }

    return (
        <Modal
            ariaLabelledby='modal-header'
            onClose={handleCloseModal}
            type='embedConfirmation'
            zIndex={theme.zIndices.embedModal.value}
            {...modalProps}
            overlayBackground
        >
            <StyledHeader>
                <CloseButton
                    aria-label={t('Close modal')}
                    color='text'
                    // eslint-disable-next-line react/no-unstable-nested-components
                    iconLeft={() => <XIcon aria-label='Close' title='Close' />}
                    onPress={handleCloseModal}
                    tabIndex={-1}
                    text=''
                    type='button'
                />
            </StyledHeader>
            <StyledContent css={
                {$$headerHeight: `${embed?.containerOptions?.headerOptions?.height || DEFAULT_HEADER_HEIGHT}px`}
            }
            >
                <StyledContentInner>
                    <StyledIconWrapper>{icon || <InformationCircleIcon aria-hidden='true' />}</StyledIconWrapper>
                    {!!title && <StyledHeading id='modal-header'>{title}</StyledHeading>}
                    <StyledText>{text}</StyledText>
                    <StyledButtons>
                        <Button color='filled' onPress={onConfirm} size='large' tabIndex={0} text={submitText || t('OK')} />
                        <Button onPress={handleCloseModal} size='large' tabIndex={-1} text={cancelText || t('Cancel')} />
                    </StyledButtons>
                </StyledContentInner>
            </StyledContent>
            <StyledFooter />
        </Modal>
    )
}

export default EmbedConfirmationPromiseModalView
